import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActivityIndicator from '../ActivityIndicator';
import Filters from '../Filters';
import Volume from './Volume';
import { getPublications, sortPublications, filterPublications } from '../../actions';
import './style.css';
import Details from './Details';

/**
 * @name Publication
 * @function
 * @description Displays Publication
 * @returns {JSX}
 * @param {*} props 
 */
function Publication( props ){
    
    const [modalVisible, setModalVisible] = useState( false );
    const [activePublication, setActivePublication] = useState( props.activePublication );

    useEffect(() => {
       props.get(); //get all publications
    }, []);

    /**
     * @name showModal
     * @param {Object} activeVolume publication object
     * @description opens modal
    */
    const showModal = (activeVolume = {}) => {
        setActivePublication( activeVolume );
        setModalVisible( true );
    }

    /**
     * @name closeModal
     * @description closes modal
    */
    const closeModal = () => setModalVisible( false );
    
    /**
     * @name callback
     * @param {Object} e Browser event object
     * @description Applies filters, sorts, and publications from the sub components without having to pass the parent component
    */
    const callback = e => {
        switch( e.type ){
            case 'filter':
                props.filterPublications( props.publications, e.filter );
                break;
            case 'sort':
                props.sortPublications( props.publications, e.sort );
                break;
            default: 
                break;
        }
    }
    
    return (
        <Fragment>
             { 
                props.publications.length === 0 ? 
                    // show activity indicator
                    <ActivityIndicator text="Loading Publications..." /> :
                    <Fragment>
                        <Filters labels={ props.data } callback={ callback }/>
                        {/* loop through publications */}
                        <div className="grid row">
                            {
                                props.publications.map(
                                    (volume, index) => {
                                        return (
                                            <Volume
                                                volume={ volume }
                                                name={ `${ props.data.DictionaryLabels.Volume } ${ volume.volume },`}
                                                number={ ` ${ props.data.DictionaryLabels.Number } ${ volume.number }` }
                                                key={ `publication-${index}` }
                                                imgkey={ `img-${index}` } 
                                                callback={showModal}/>
                                        )
                                    }
                                )
                            }
                            <Details visible={ modalVisible } onClose={ closeModal } labels={ props.data.DictionaryLabels }{...activePublication}/>
                        </div>
                    </Fragment>
            }
        </Fragment>
           
    );
}


Publication.defaultProps = {
    activePublication:{
        publication:{
            volume:  null,
            number:  null,
            imageUrl: '',
            pdfUrl: '',
            articles: []
        }
    },
    publications: []
};

Publication.propTypes = {
    get: PropTypes.func.isRequired,
    sortPublications: PropTypes.func.isRequired,
    filterPublications: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    publications: PropTypes.arrayOf(
        PropTypes.shape({
            volume: PropTypes.number,
            imageUrl: PropTypes.string,
            pdfUrl: PropTypes.string,
            publishDate: PropTypes.instanceOf(Date),
            number: PropTypes.number,
            articles: PropTypes.array
        })
    ).isRequired
}


const mapStateToProps = state => ({
    publications: state.archives.publications
});

const mapDispatchToProps = dispatch => bindActionCreators({ get: getPublications, sortPublications, filterPublications }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Publication);
